import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.indigo[600],
    height: 56,
    width: 56
  }
}));

const ReceivedTrodes = ({ className, count, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              RECEIVED TRODES
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {count}
            </Typography>
          </Grid>

          <Grid item>
            <Avatar className={classes.avatar}>
              <AssignmentTurnedInIcon />
            </Avatar>
          </Grid>
        </Grid>

        <Box mt={2} display="flex" alignItems="center">
          <Typography
            color="textSecondary"
            variant="caption"
          >
            All Trodes received in the last 90 days
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

ReceivedTrodes.propTypes = {
  className: PropTypes.string
};

export default ReceivedTrodes;
